import { TermsStatus } from '../types/terms';

/**
 * Login gates (the blocking EUTC acceptance modal and the forced password
 * change dialog) cover the whole app right after login. Anything that wants
 * to interact with the user on first login (e.g. the onboarding tour) must
 * wait until every gate has cleared.
 *
 * A null termsStatus means an older backend that sends no gate information —
 * treated as "no gates" (see TermsStatus docs in types/terms.ts).
 */
export const areLoginGatesCleared = (termsStatus: TermsStatus | null): boolean => {
  if (termsStatus === null) {
    return true;
  }
  return termsStatus?.eutcAccepted !== false && termsStatus?.mustChangePassword !== true;
};
